import { useRef, useState, useCallback } from 'react';

/**
 * Custom hook for managing audio playback
 * Handles playing/pausing audio and tracking which item is currently playing
 */
export const useAudioPlayback = () => {
  const audioRef = useRef(new Audio());
  const [playingId, setPlayingId] = useState(null);

  const playSound = useCallback((soundUrl, id) => {
    if (!soundUrl) return;

    // If clicking the same sound that's playing, stop it
    if (playingId === id) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setPlayingId(null);
      return;
    }

    // Stop any currently playing audio
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }

    // Set up new audio
    audioRef.current.src = soundUrl;
    setPlayingId(id);

    // Handle when audio ends
    audioRef.current.onended = () => {
      setPlayingId(null);
    };

    // Handle errors
    audioRef.current.onerror = () => {
      console.warn('Failed to play audio:', soundUrl);
      setPlayingId(null);
    };

    // Play the audio
    audioRef.current.play().catch((error) => {
      console.warn('Error playing audio:', error);
      setPlayingId(null);
    });
  }, [playingId]);

  return {
    playingId,
    playSound,
  };
};
